import { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import {
  selectIsMessageLoading,
  selectMeetingValue,
} from "../../../redux/selectors";
import { useStorageSelectors } from "../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppDispatch } from "../../../../../services/redux/hooks/use-dispatch";
import { useTranslation } from "react-i18next";
import { useLLMSelections } from "../../../hooks/use-llm-selections";
import { setMeetingSelectedAssistant } from "../../../redux/slice";
import { useInitAssistantOptions } from "../../../../../common/Components/Selects/hooks/use-init-assistants-options";
import { AssistantSelect } from "../../../../../common/Components/Selects/Components/AssistantSelect";
import { ModelsSelect } from "../../../../../common/Components/Selects/Components/ModelSelects";
import styles from "./styles.module.css";

export const MeetingLLMSelections = () => {
  const dispatch = useAppDispatch();
  const { handleSelectAssistant, handleSelectModel } = useLLMSelections();
  const { selectedId } = useStorageSelectors("meetings");
  const value = useAppSelector(selectMeetingValue);
  const { assistants } = useInitAssistantOptions();
  const isMessageLoading = useAppSelector(selectIsMessageLoading);
  const { t } = useTranslation();

  const selectedAssist = useMemo(() => {
    if (!value?.meetings_object?.llm_selection) return null;
    const currentAssistant =
      assistants.find(
        (assist) =>
          assist.ref === value.meetings_object?.llm_selection?.assistant_ref,
      ) || null;
    return currentAssistant;
  }, [assistants, value?.meetings_object?.llm_selection?.assistant_ref]);

  useEffect(() => {
    if (selectedAssist !== undefined) {
      dispatch(setMeetingSelectedAssistant(selectedAssist));
    }
  }, [selectedAssist, dispatch]);

  if (!selectedId) return null;

  return (
    <div className={styles["selection-container"]}>
      <AssistantSelect
        assistants={assistants}
        assistant={selectedAssist}
        onSelectAssistant={handleSelectAssistant}
        isDisabled={isMessageLoading}
        emptyOptionLabel={t("app_selects.without_assistant")}
      />
      {selectedAssist === null && (
        <ModelsSelect
          modelId={value?.meetings_object?.llm_selection?.model ?? "free"}
          updateObject={handleSelectModel}
          isDisabled={isMessageLoading}
        />
      )}
    </div>
  );
};
